import { z } from "zod/v4"

/**
 * 孤立サロゲート（lone surrogate）が含まれていないかチェックする。
 * JavaScript の文字列は UTF-16 で、サロゲートペアの片割れだけが含まれる場合がある。
 * これは有効な UTF-8 に変換できないため、Firestore の gRPC 層で INVALID_ARGUMENT になる。
 */
const hasLoneSurrogate = (s: string): boolean => {
  for (let i = 0; i < s.length; i++) {
    const code = s.charCodeAt(i)
    if (0xD800 <= code && code <= 0xDBFF) {
      const next = s.charCodeAt(i + 1)
      if (Number.isNaN(next) || 0xDFFF < next || next < 0xDC00) return true
      i++
    } else if (0xDC00 <= code && code <= 0xDFFF) {
      return true
    }
  }
  return false
}

export const validateUserFreeInputText = (p: {minLength: number, maxLength: number}) => {
  return z.string().trim().min(p.minLength).max(p.maxLength).refine(
    (s) => !hasLoneSurrogate(s),
    "無効な文字が含まれています。"
  )
}
